import React from 'react';
import add from '../../../../assets/image/add.svg';
import closei from '../../../../assets/image/x-square.svg';

function EWayBillForm({ purchaseBillFormData, setPurchaseBillFormData, setIsBillModalOpen }) {
	return (
		<div>
			{(purchaseBillFormData?.e_way_bill?.e_way_bill_no &&
				purchaseBillFormData?.e_way_bill?.e_way_bill_status) ||
			purchaseBillFormData?.e_way_bill?.e_way_bill_id ? (
				<div
					className="col-3"
					style={{ margin: '10px 0px', height: '72px' }}
				>
					<div className="col">
						<div
							style={{
								display: 'flex',
								flexDirection: 'row',
								justifyContent: 'space-between',
								alignItems: 'center',
							}}
						>
							<p style={{ fontSize: '14px', fontWeight: 600 }}>E-Way Bill #</p>
							<p
								style={{ color: '#0d6efd', cursor: 'pointer', fontSize: '11px' }}
								onClick={() => setIsBillModalOpen(true)}
							>
								View Details
							</p>
						</div>
						<div
							style={{
								height: '34px',
								backgroundColor: '#fcfcfc',
								border: '1px solid rgba(85, 91, 103, 0.15)',
								borderRadius: '6px',
								padding: '8px',
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
							}}
						>
							<p style={{ paddingTop: '9px' }}>{purchaseBillFormData?.e_way_bill?.e_way_bill_no}</p>
							<div
								style={{
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
									width: '20px',
									height: '20px',
									backgroundColor: 'red',
									borderRadius: '100%',
									cursor: 'pointer',
								}}
								onClick={() => {
									setPurchaseBillFormData((prev) => ({
										...prev,
										e_way_bill: {
											e_way_bill_no: '',
											challan_no: '',
											due_date: '',
											transport: '',
											cases: '',
											purchase_tax: '',
											remarks: '',
											e_way_bill_status: false,
										},
									}));
								}}
							>
								<img
									className="add-pro"
									style={{
										width: '10px',
										height: '10px',
										objectFit: 'contain',
									}}
									alt="close"
									src={closei}
								/>
							</div>
						</div>
					</div>
				</div>
			) : (
				<button
					className="d-flex align-items-center justify-content-around"
					style={{
						height: '32px',
						width: '160px',
						backgroundColor: '#3B58FF',
						marginTop: '12px',
					}}
					onClick={() => setIsBillModalOpen(true)}
				>
					<img
						src={add}
						alt=""
					/>{' '}
					Add E-Way Bill
				</button>
			)}
		</div>
	);
}

export default EWayBillForm;
